import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Navigation = ({ userData }) => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    setIsMobileMenuOpen(false);
    
    // Use a more reliable scrolling method
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80; // Account for fixed navbar height
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/90 backdrop-blur-sm' : 'bg-transparent'
      }`}
      style={{
        background: scrolled 
          ? 'linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 70%, rgba(0,0,0,0) 100%)'
          : 'transparent'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Left side - Profile */}
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center">
               <span className="text-white text-sm font-medium">P</span>
            </div>
            <span className="text-white font-medium">Prabhakar</span>
          </div>

          {/* Right side - Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <motion.a
              href="#portfolio"
              whileHover={{ scale: 1.05 }}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('portfolio');
              }}
              className="text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer"
            >
              Portfolio
            </motion.a>
            <motion.a
              href="#about"
              whileHover={{ scale: 1.05 }}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('about');
              }}
              className="text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer"
            >
              About
            </motion.a>
            <motion.a
              href="#contact"
              whileHover={{ scale: 1.05 }}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('contact');
              }}
              className="text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer"
            >
              Contact
            </motion.a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={toggleMobileMenu}
              className="text-white hover:text-gray-300 transition-colors duration-300 p-2"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </motion.button>
          </div>

        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ 
          opacity: isMobileMenuOpen ? 1 : 0,
          height: isMobileMenuOpen ? 'auto' : 0
        }}
        transition={{ duration: 0.3 }}
        className="md:hidden bg-black/95 backdrop-blur-sm border-t border-white/10 overflow-hidden"
      >
        <div className="px-6 py-4 space-y-4">
          <motion.a
            href="#portfolio"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('portfolio');
            }}
            className="block text-white hover:text-gray-300 transition-colors duration-300 py-2"
          >
            Portfolio
          </motion.a>
          <motion.a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('about');
            }}
            className="block text-white hover:text-gray-300 transition-colors duration-300 py-2"
          >
            About
          </motion.a>
          <motion.a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('contact');
            }}
            className="block text-white hover:text-gray-300 transition-colors duration-300 py-2"
          >
            Contact
          </motion.a>
        </div>
      </motion.div>
    </motion.nav>
  );
};

export default Navigation;
